function formatDateToMMDD() {
  let date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  const month = date.toLocaleDateString('en-US', {
    month: '2-digit'
  });
  const day = date.toLocaleDateString('en-US', {
    day: '2-digit'
  });
  return `${month}/${day}`;
}
export { formatDateToMMDD as default };
